import { MissingEventCallbackError } from '../errors';

function createEventBus() {
  let eventObject = new Map();
  // Payloads emitted with { sticky: true } are kept and replayed to listeners
  const stickyPayloadMap = new Map();

  // Subscribe to events; { sticky: false } opts out of replaying a retained
  // sticky payload to this listener (defaults to true).
  function addEventListener(eventName, callback, options) {
    if (!callback) throw new MissingEventCallbackError(eventName);

    if (!eventObject.has(eventName)) {
      eventObject.set(eventName, new Set());
    }

    eventObject.get(eventName).add(callback);

    const sticky = options?.sticky ?? true;
    if (sticky && stickyPayloadMap.has(eventName)) {
      callback(stickyPayloadMap.get(eventName));
    }
  }

  // Remove event listener
  function removeEventListener(eventName, callback) {
    if (!callback) throw new MissingEventCallbackError(eventName);

    if (!eventObject.has(eventName)) {
      return;
    }

    const eventListeners = eventObject.get(eventName);
    eventListeners.delete(callback);

    if (eventListeners.size === 0) {
      eventObject.delete(eventName);
    }
  }

  // Emit event; { sticky: true } keeps the payload for replay to late listeners
  function emit(eventName, payload, options) {
    if (options?.sticky) {
      stickyPayloadMap.set(eventName, payload);
    }
    const callbacks = eventObject.get(eventName);
    if (!callbacks || callbacks.size === 0) return;

    callbacks.forEach((c) => {
      c(payload);
    });
  }

  return {
    addEventListener,
    removeEventListener,
    emit,
  };
}

const eventBus = createEventBus();

export default eventBus;
